<script setup>
import { ref } from 'vue'

const props = defineProps({
	src: {
		type: String,
		default: '',
		required: false,
	},
	alt: {
		type: String,
		default: '',
		required: true,
	},
	additionalClasses: {
		type: String,
		default: '',
		required: false,
	},
	toFadeIn: {
		type: Boolean,
		default: false,
		required: false,
	},
	isOverflow: {
		type: Boolean,
		default: false,
		required: false,
	},
	width: {
		type: String,
		default: '',
		required: false,
	},
	height: {
		type: String,
		default: '',
		required: false,
	},
})

const isImageLoaded = ref(false)
function imageLoaded() {
	if (props.toFadeIn) {
		isImageLoaded.value = true
	}
}
</script>

<template>
	<img
		v-bind="$attrs"
		:key="src"
		class="object-center object-cover"
		:class="{
			'fade-in': isImageLoaded,
			fade: toFadeIn,
			absolute: isOverflow,
			[additionalClasses]: true,
			[width]: true,
			[height]: true,
		}"
		:src="src"
		:alt="alt"
		preload
		@load="imageLoaded"
	/>
</template>
